const STORAGE_KEY = 'apiDocReturnPath';

/** Parse ?redirect=/api/doc from the login page URL. */
export function getApiDocRedirectFromSearch(search = window.location.search) {
  if (typeof search !== 'string' || search === '') {
    return null;
  }

  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);

  return normalizeApiDocReturnPath(params.get('redirect'));
}

const API_DOC_PATH_PATTERN = /^\/api\/doc(?:\.json|\/|$)/;

export function normalizeApiDocReturnPath(redirect) {
  if (typeof redirect !== 'string' || !API_DOC_PATH_PATTERN.test(redirect)) {
    return null;
  }

  if (redirect.startsWith('//')) {
    return null;
  }

  return redirect;
}

export function captureApiDocRedirectFromSearch(search = window.location.search) {
  const path = getApiDocRedirectFromSearch(search);

  if (path && typeof window !== 'undefined' && window.sessionStorage) {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  }

  return path;
}

export function getApiDocRedirectTarget(search = window.location.search) {
  return getApiDocRedirectFromSearch(search) || getStoredApiDocRedirect();
}

export function getStoredApiDocRedirect() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }

  return normalizeApiDocReturnPath(window.sessionStorage.getItem(STORAGE_KEY));
}

export function clearApiDocRedirect() {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }
}

export function isApiDocLoginFlow(search = window.location.search) {
  return getApiDocRedirectTarget(search) !== null;
}

/** Full-page navigation so /api/doc is gated by the refresh-token cookie only. */
export function redirectToApiDoc(path) {
  clearApiDocRedirect();

  // Defer so Set-Cookie from POST /api/login_check is committed before GET /api/doc.
  window.setTimeout(() => {
    window.location.replace(path);
  }, 50);
}
